/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	import View = alm.view.View;
	import Num = alm.util.Num;

	export class LandmarkPin extends View<THREE.Object3D> {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(data:ActivityLandmark, zoomLevel:number) {
			super(new THREE.Object3D());

			this.data = data;
			this.zoomLevel = zoomLevel;

			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize():THREE.Object3D {
			const latLng:LatLng = this.data.getPosition();
			latLng.calcPixelCoord(this.zoomLevel);

			this.position = Unit.pixelElevationToSpace(latLng.getPixel(), this.data.getAltitude(), this.zoomLevel);
			this.position.y += 2;

			this.threeManager = ThreeManager.getInstance();
			this.screenPosition = new THREE.Vector3();

			this.setupSprite();
			this.setupLabel();
			this.setupLine();

			this.update();

			return this.getView();
		}

		protected implReady():void {
		}

		protected implFinalize():void {
			this.data = null;
			this.label = null;
		}

		protected implShow(view:THREE.Object3D, useTransition:boolean):cmd.Command {
			return new cmd.Command();
		}

		protected implHide(view:THREE.Object3D, useTransition:boolean):cmd.Command {
			return new cmd.Command();
		}

		public update():void {
			this.labelPosition.set(this.position.x, this.position.y + this.lineHeight, this.position.z);
			this.threeManager.project(this.labelPosition, this.screenPosition);
			this.label.css({
				left: this.screenPosition.x,
				top: this.screenPosition.y,
				display: this.screenPosition.z > 1 ? 'none' : 'block',
			});

			const distance = this.position.distanceTo(this.threeManager.getCameraPosition());
			const labelScale = Num.map(distance, 100, 2500, 1.2, 0.3);
			this.label.css('transform', 'scale(' + labelScale + ', ' + labelScale + ')');
		}

		private setupSprite():void {
			// material
			this.spriteTexture = new THREE.TextureLoader().load('image/route-head-particle.png');
			this.spriteMaterial = new THREE.SpriteMaterial({
				map: this.spriteTexture,
				color: 0xffffff,
				transparent: true,
				depthWrite: false
			});

			this.sprite = new THREE.Sprite(this.spriteMaterial);
			this.getView().add(this.sprite);

			const scale:number = 6;
			this.sprite.scale.set(scale, scale, scale);
			this.sprite.position.copy(this.position);
		}

		private setupLabel():void {
			this.label = jQuery('#landmark-label-template').clone();
			this.label.find('.name').text(this.data.getName());

			this.labelPosition = new THREE.Vector3();

			jQuery('#landmark-label-container').append(this.label);
		}

		private setupLine():void {
			this.lineHeight = 40;

			const material:THREE.LineBasicMaterial = new THREE.LineBasicMaterial({
				color: 0xffffff,
				opacity: 0.5,
				transparent: true
			});

			const geometry:THREE.Geometry = new THREE.Geometry();
			geometry.vertices.push(this.position);
			geometry.vertices.push(new THREE.Vector3(this.position.x, this.position.y + this.lineHeight, this.position.z));

			this.line = new THREE.LineSegments(geometry, material);
			this.getView().add(this.line);
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private data:ActivityLandmark;
		private zoomLevel:number;
		private position:THREE.Vector3;
		private threeManager:ThreeManager;
		private screenPosition:THREE.Vector3;

		private sprite:THREE.Sprite;
		private spriteTexture:THREE.Texture;
		private spriteMaterial:THREE.SpriteMaterial;

		private line:THREE.LineSegments;
		private lineHeight:number;

		private label:JQuery;
		private labelPosition:THREE.Vector3;
	}
}
